import React from 'react';
import { ReactComponent as VisaLogo } from 'assets/logos/visa.svg';
import { ReactComponent as MastercardLogo } from 'assets/logos/mastercard.svg';
import { ReactComponent as AmexLogo } from 'assets/logos/amex.svg';
import { ReactComponent as DefaultCardLogo } from 'assets/logos/credit_card.svg';
import { ReactComponent as BankAccountLogo } from 'assets/logos/bank_account.svg';

import { PaymentMethod, CardPaymentMethod, BankPaymentMethod } from 'types/Billing';

import fonts from 'styles/typography.module.css';

const NoMethod: React.FC = () => (
  <div className="w-full p-4 flex items-center space-x-2">
    <h4 className="text-gray-700">No saved cards</h4>
  </div>
);
NoMethod.displayName = 'PaymentMethodItem.NoMethod';

const CardMethod: React.FC<{ value: CardPaymentMethod }> = (props) => {
  const { value } = props;
  const cardLogos: Record<string, JSX.Element> = {
    visa: <VisaLogo />,
    amex: <AmexLogo />,
    mastercard: <MastercardLogo />,
  };
  return (
    <>
      {cardLogos[value.card.brand] || <DefaultCardLogo />}
      <h4 className="font-regular text-dark">
        {value.card.brand.toUpperCase()}
        ····-
        {value.card.last4}, exp{' '}
        {value.card.expMonth < 10 ? `0${value.card.expMonth}` : value.card.expMonth}/
        {value.card.expYear}
      </h4>
    </>
  );
};
CardMethod.displayName = 'PaymentMethodtem.CardMethod';

export const BankMethod: React.FC<{ value: BankPaymentMethod }> = (props) => {
  const { value } = props;
  return (
    <>
      <BankAccountLogo fill="black" stroke="black" />
      <h4 className="font-regular text-dark">
        {value.bankName}
        ************
        {value.last4}
      </h4>
      {value.accountName && <h6>{value.accountName}</h6>}
    </>
  );
};
BankMethod.displayName = 'PaymentMethodItem.BankMethod';

const PaymentMethodItem: React.FC<{ value: PaymentMethod | string; isDefault?: boolean }> = ({
  value,
  isDefault,
}) => {
  if (typeof value === 'string') {
    return <NoMethod />;
  }

  let method: JSX.Element | null = null;
  switch (value.object) {
    case 'payment_method':
      method = <CardMethod value={value} />;
      break;
    case 'bank_account':
      method = <BankMethod value={value} />;
      break;
    default:
      break;
  }

  return (
    <div className={`w-full p-4 flex items-center space-x-2 ${fonts.font}`}>
      {method}
      {isDefault && <p>(default)</p>}
    </div>
  );
};
PaymentMethodItem.displayName = 'PaymentMethod';

export default PaymentMethodItem;
